import { Layout } from '@/utils/routerHelper'

// 营销管理
export default {
  path: '/marketing',
  redirect: '/marketing/coupon',
  component: Layout,
  name: 'Marketing',
  meta: {
    title: '营销管理',
    icon: 'vi-ant-design:dashboard-filled',
    alwaysShow: true
  },
  children: [
    {
      path: 'coupon',
      component: () => import('@/views/Marketing/Coupon/CouponList/Index.vue'),
      name: 'Coupon',
      meta: {
        title: '优惠券模板列表'
      },
      children: [
        {
          path: 'edit-coupon',
          component: () => import('@/views/Marketing/Coupon/EditCoupon/Index.vue'),
          name: 'EditCoupon',
          meta: {
            title: '编辑优惠券',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon'
          }
        },
        {
          path: 'coupon-detail',
          component: () => import('@/views/Marketing/Coupon/CouponDetail/Index.vue'),
          name: 'CouponDetail',
          meta: {
            title: '优惠券模板详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon'
          }
        },
        {
          path: 'reissue-record',
          component: () => import('@/views/Marketing/Coupon/ReissueRecord/Index.vue'),
          name: 'CouponReissueRecord',
          meta: {
            title: '补发记录',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon'
          }
        },
        {
          path: 'coupon-task',
          component: () => import('@/views/Marketing/Coupon/TaskList/Index.vue'),
          name: 'CouponTempTask',
          meta: {
            title: '优惠券发放任务',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon'
          }
        },
        {
          path: 'coupon-detail-list',
          component: () => import('@/views/Marketing/Coupon/CouponDetailList/Index.vue'),
          name: 'CouponInstanceList',
          meta: {
            title: '优惠券明细列表',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon'
          }
        }
      ]
    },
    {
      path: 'coupon-temp-audit',
      component: () => import('@/views/Marketing/CouponTempAudit/AuditList/Index.vue'),
      name: 'CouponTempAudit',
      meta: {
        title: '优惠券模板审批'
      },
      children: [
        {
          path: 'audit-detail',
          component: () => import('@/views/Marketing/CouponTempAudit/AuditDetail/Index.vue'),
          name: 'CouponTempAuditDetail',
          meta: {
            title: '优惠券模板审核详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon-temp-audit'
          }
        }
      ]
    },
    {
      path: 'coupon-task',
      component: () => import('@/views/Marketing/CouponTask/TaskList/Index.vue'),
      name: 'CouponTask',
      meta: {
        title: '发放任务管理列表'
      },
      children: [
        {
          path: 'edit',
          component: () => import('@/views/Marketing/CouponTask/EditTask/Index.vue'),
          name: 'EditCouponTask',
          meta: {
            title: '编辑发放任务',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon-task'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Marketing/CouponTask/TaskDetail/Index.vue'),
          name: 'CouponTaskDetail',
          meta: {
            title: '发放任务详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon-task'
          }
        },
        {
          path: 'task-detail-list',
          component: () => import('@/views/Marketing/CouponTask/TaskDetailList/Index.vue'),
          name: 'CouponTaskDetailList',
          meta: {
            title: '已发放任务明细列表',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon-task'
          }
        }
      ]
    },
    {
      path: 'coupon-task-audit',
      component: () => import('@/views/Marketing/CouponTaskAudit/AuditList/Index.vue'),
      name: 'CouponTaskAudit',
      meta: {
        title: '优惠券发放任务审批'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Marketing/CouponTaskAudit/AuditDetail/Index.vue'),
          name: 'CouponTaskAuditDetail',
          meta: {
            title: '发放任务审核详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/coupon-task-audit'
          }
        }
      ]
    },
    {
      path: 'coupon-entity-details',
      component: () => import('@/views/Marketing/CouponEntityDetails/Index.vue'),
      name: 'CouponEntityDetails',
      meta: {
        title: '优惠券明细列表'
      }
    },
    {
      path: 'task-entity-details',
      component: () => import('@/views/Marketing/CouponTaskEntityDetails/Index.vue'),
      name: 'CouponTaskEntityDetails',
      meta: {
        title: '已发放优惠券明细列表'
      }
    },
    {
      path: 'client-coupon',
      component: () => import('@/views/Marketing/ClientCoupon/ClientCouponList/Index.vue'),
      name: 'ClientCouponList',
      meta: {
        title: '顾客优惠券查询列表'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Marketing/ClientCoupon/ClientCouponDetail/Index.vue'),
          name: 'ClientCouponDetail',
          meta: {
            title: '顾客优惠券明细',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/client-coupon'
          }
        }
      ]
    },
    {
      path: 'monthly-purchase-audit',
      component: () => import('@/views/Marketing/MonthlyPurchaseAudit/AuditList/Index.vue'),
      name: 'MonthlyPurchaseAudit',
      meta: {
        title: '月购卡扣除审批'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Marketing/MonthlyPurchaseAudit/AuditDetail/Index.vue'),
          name: 'MonthlyPurchaseAuditDetail',
          meta: {
            title: '月购卡扣除审批详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/monthly-purchase-audit'
          }
        }
      ]
    },
    {
      path: 'promotion-activity',
      component: () => import('@/views/Marketing/PromotionActivity/ActiveList/Index.vue'),
      name: 'PromotionActivity',
      meta: {
        title: '促销活动管理'
      },
      children: [
        {
          path: 'edit',
          component: () => import('@/views/Marketing/PromotionActivity/EditActive/Index.vue'),
          name: 'EditPromotionActivity',
          meta: {
            title: '新增促销活动',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/promotion-activity'
          }
        },
        {
          path: 'add-combination-product',
          component: () =>
            import('@/views/Marketing/PromotionActivity/AddCombinationProduct/Index.vue'),
          name: 'AddCombinationProduct',
          meta: {
            title: '添加产品组合',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/promotion-activity'
          }
        },
        {
          path: 'product-detail',
          component: () => import('@/views/Marketing/PromotionActivity/ProductDetail/Index.vue'),
          name: 'CombinationProductDetail',
          meta: {
            title: '产品组合详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/promotion-activity'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Marketing/PromotionActivity/ActivityDetail/Index.vue'),
          name: 'ActivityDetail',
          meta: {
            title: '促销活动详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/promotion-activity'
          }
        }
      ]
    },
    {
      path: 'promotion-activity-audit',
      component: () => import('@/views/Marketing/PromotionActivityAudit/AuditList/Index.vue'),
      name: 'PromotionActivityAudit',
      meta: {
        title: '促销活动审批'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Marketing/PromotionActivityAudit/AuditDetail/Index.vue'),
          name: 'PromotionActivityAuditDetail',
          meta: {
            title: '促销活动审批详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/promotion-activity-audit'
          }
        }
      ]
    },
    {
      path: 'promotion-activity-client',
      component: () => import('@/views/Marketing/PromotionActivityClient/Index.vue'),
      name: 'PromotionActivityClient',
      meta: {
        title: '促销活动参与顾客列表'
      }
    },
    {
      path: 'promotion-activity-strategy',
      component: () => import('@/views/Marketing/PromotionActivityStrategy/Index.vue'),
      name: 'PromotionActivityStrategy',
      meta: {
        title: '促销活动策略管理'
      },
      children: [
        {
          path: 'edit',
          component: () =>
            import('@/views/Marketing/PromotionActivityStrategy/EditStrategy/Index.vue'),
          name: 'EditStrategy',
          meta: {
            title: '促销活动策略',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/promotion-activity-strategy'
          }
        },
        {
          path: 'detail',
          component: () =>
            import('@/views/Marketing/PromotionActivityStrategy/StrategyDetail/Index.vue'),
          name: 'StrategyDetail',
          meta: {
            title: '策略详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/promotion-activity-strategy'
          }
        }
      ]
    },
    {
      path: 'event-marketing',
      component: () => import('@/views/Marketing/EventMarketing/EventList/Index.vue'),
      name: 'EventMarketing',
      meta: {
        title: '事件营销管理'
      },
      children: [
        {
          path: 'edit',
          component: () => import('@/views/Marketing/EventMarketing/EditEvent/Index.vue'),
          name: 'EditEvent',
          meta: {
            title: '事件营销',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/event-marketing'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Marketing/EventMarketing/EventDetail/Index.vue'),
          name: 'EditEventDetail',
          meta: {
            title: '事件营销详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/event-marketing'
          }
        },
        {
          path: 'record',
          component: () => import('@/views/Marketing/EventMarketing/WarnRecord/Index.vue'),
          name: 'EditEventWarnRecord',
          meta: {
            title: '提醒记录详情列表',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/event-marketing'
          }
        },
        {
          path: 'statistics',
          component: () => import('@/views/Marketing/EventMarketing/StatisticsDetails/Index.vue'),
          name: 'EditEventStatisticsDetails',
          meta: {
            title: '统计明细详情列表',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/event-marketing'
          }
        }
      ]
    },
    {
      path: 'event-marketing-audit',
      component: () => import('@/views/Marketing/EventMarketingAudit/AuditList/Index.vue'),
      name: 'EventMarketingAudit',
      meta: {
        title: '事件营销审批'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Marketing/EventMarketingAudit/AuditDetail/Index.vue'),
          name: 'EventMarketingAuditDetail',
          meta: {
            title: '事件营销详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/event-marketing-audit'
          }
        }
      ]
    },
    {
      path: 'group-purchase',
      component: () => import('@/views/Marketing/GroupPurchase/GroupPurchaseList/Index.vue'),
      name: 'GroupPurchaseList',
      meta: {
        title: '团购活动列表'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Marketing/GroupPurchase/GroupPurchaseDetail/Index.vue'),
          name: 'GroupPurchaseDetail',
          meta: {
            title: '团购活动详情',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/group-purchase'
          }
        },
        {
          path: 'edit',
          component: () => import('@/views/Marketing/GroupPurchase/GroupPurchaseEdit/Index.vue'),
          name: 'GroupPurchaseEdit',
          meta: {
            title: '团购活动编辑',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/group-purchase'
          }
        },
        {
          path: 'group',
          component: () => import('@/views/Marketing/GroupPurchase/GroupList/Index.vue'),
          name: 'GroupList',
          meta: {
            title: '成团列表',
            hidden: true,
            canTo: true,
            activeMenu: '/marketing/group-purchase'
          }
        }
      ]
    }
  ]
} as AppRouteRecordRaw
